module.exports = __webpack_public_path__ + "img/tram-green.48bc1702.svg";